import React from 'react';
import FooterHero from '../../component/common/CTA'
import HeroSection from '../../component/common/hero'
import HowWeHelp from '../../component/common/howWeHelp'
import CaseStudySlider from '../../component/common/caseStudy'

const caseStudiesData = [
  {
    image: "img/logos/dalmia.png",
    heading: "Dalmia Bharat",
    content:
      "Dalmia Bharat faced a critical challenge—reducing their order-to-delivery cycle from 7 days to just 24 hours. TurningIdeas stepped in to identify, match, and co-create a solution by connecting them with TurningCloud Technologies, an innovative tech startup. Together, we developed mSuvidha, a mobile app that streamlined dealer ordering, improved supply chain efficiency, and enhanced real-time order tracking. This collaboration not only cut delivery times drastically but also boosted dealer engagement and revenue growth for Dalmia Bharat, showcasing the power of startup-enterprise innovation.",
    link: "https://www.dalmiabharat.com/",
  },
  {
    image: "img/logos/whizdom.png",
    heading: "Whizdom Club",
    content:
      "TurningIdeas Ventures partnered with Whizdom Club India, a venture by Magnolia Quality Development Corporation (MQDC) Thailand, to establish and scale their premium innovation and coworking space in India. We provided end-to-end market entry strategy, brand positioning, and community-building initiatives, ensuring a seamless launch in the highly competitive Indian market. From curating startup engagement programs to driving occupancy growth and partnerships, we played a key role in positioning Whizdom Club as a hub for entrepreneurs, innovators, and creatives. Our expertise in business acceleration and corporate innovation helped Whizdom India achieve rapid traction and a strong foothold in the ecosystem. 🚀",
    link: "https://www.whizdomindia.com/",
  },
];

const heroData = {
  title: {
    bold: "Enterprises",
    light: "",
  },
  subtitle: "Partner with Disruptive Startups",
  description: {
    heading: "Unlock Innovation Through Startup Collaborations",
    intro: "Large enterprises need disruptive technology and agile innovation, but finding the right startup partners can be challenging. We bridge the gap.",
    outro: ""
  },
  highlightedText: "",
  heroImage: "img/enterprise-hero.png",
  bgImg: "img/enterprise-hero-bg.png",
  btnText: "Partner with Startups",
  btnLink: "https://forms.gle/hRT1f96s5cWEg16U8"
};

const serviceCards = [
  {
    title: "Startup Scouting & Curation",
    text: "Identifying top startups solving key industry challenges.",
    subtext: "",
    iconLink: "img/enterprise-help1.png"
  },
  {
    title: "Integration & Scaling",
    text: "Seamlessly adopting startup innovations into enterprise workflows.",
    subtext: "",
    iconLink: "img/enterprise-help2.png"
  },
  {
    title: "Pilot Programs & (PoCs)",
    text: "Validating startup solutions in real-world scenarios.",
    subtext: "",
    iconLink: "img/enterprise-help3.png"
  },
  {
    title: "Corporate Venture Engagement",
    text: "Helping enterprises invest in high-growth startups.",
    subtext: "",
    iconLink: "img/enterprise-help4.png"
  }
];

const statsDataHeading = {
  light: "Industries",
  bold: "We Work With:"
}

const statsData = [
  {
    text: "Healthcare & MedTech",
    img: "img/industry1.png"
  },
  {
    text: "FinTech & Banking",
    img: "img/industry2.png"
  },
  {
    text: "E-commerce & Retail",
    img: "img/industry3.png"
  },
  {
    text: "Manufacturing & Industry 4.0",
    img: "img/industry4.png"
  },
  {
    text: "Sustainability & CleanTech",
    img: "img/industry5.png"
  }
];

const worldMapImg = "img/why-enterprise.png";


const headerData = {
  title: "How We Help",
  highlightedText: "Enterprises",
  normalText: "Innovate",
  description: "From idea to exit, together. when we partner with founders, we're all in combining expertise, empathy, embedded resources, and capital to build breakout companies",
  imgLink: "img/help-enterprise.png"
};

const EnterprisePage = () => {
  return (
    <div>
      <HeroSection
        title={heroData.title}
        subtitle={heroData.subtitle}
        description={heroData.description}
        highlightedText={heroData.highlightedText}
        callToAction={heroData.callToAction}
        heroImage={heroData.heroImage}
        bgImg={heroData.bgImg}
        btnText={heroData.btnText}
        btnLink={heroData.btnLink}
      />



      <section className="py-6 md:py-12">
        <div className="container mx-auto px-6 md:px-12">
          <HowWeHelp
            headerData={headerData}
            serviceCards={serviceCards}
            statsDataHeading={statsDataHeading}
            statsData={statsData}
            worldMapImg={worldMapImg}
          />
        </div>
      </section>

      <section className="py-6 md:py-12 bg-black">
        <div className="container mx-auto px-6 md:px-12">
          <CaseStudySlider caseStudies={caseStudiesData} />
        </div>
      </section>


      <FooterHero
        heading="Let’s Build Together"
        subheading="Join the TurningIdeas Ecosystem"
        paragraph="Whether you're a startup, investor, or enterprise, we help you scale, innovate, and succeed."
        buttonText="Contact Us Today!"
      />
    </div>
  );
};

export default EnterprisePage;
